import {
  Box,
  Button,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import { useState } from "react";
import { useTranslate } from "../../components/Translate/TranslateContext";

export default function GardenIrrigation({
  garden,
  onNext,
}) {
  const { translate } =
    useTranslate();

  const [rows, setRows] =
    useState([]);

  const handleFile = (
    file
  ) => {
    const reader =
      new FileReader();

    reader.onload = (
      e
    ) => {
      const text =
        e.target.result;

      const lines =
        text
          .split("\n")
          .filter(Boolean);

      const parsed =
        lines
          .slice(1)
          .map((line) => {
            const [
              datetime,
              irrigation_mm,
            ] =
              line.split(
                ","
              );

            return {
              datetime:
                datetime?.trim(),
              irrigation_mm:
                irrigation_mm?.trim(),
            };
          });

      setRows(parsed);
    };

    reader.readAsText(
      file
    );
  };

  const handleDrop = (
    e
  ) => {
    e.preventDefault();

    const file =
      e.dataTransfer
        .files[0];

    if (file)
      handleFile(
        file
      );
  };

  return (
    <Box>
      <Typography
        variant="h6"
        sx={{ mb: 2 }}
      >
        {translate(
          "irrigation"
        )}
      </Typography>

      {rows.length ===
        0 && (
        <>
          <Typography
            sx={{
              mb: 2,
            }}
          >
            {translate(
              "irrigation_tip"
            )}
          </Typography>

          <Box
            onDragOver={(
              e
            ) =>
              e.preventDefault()
            }
            onDrop={
              handleDrop
            }
            sx={{
              border:
                "2px dashed #D4E9CF",
              borderRadius:
                "16px",
              p: 5,
              textAlign:
                "center",
              cursor:
                "pointer",
              background:
                "#FFFFFF",
              transition:
                "0.2s ease",
              "&:hover":
                {
                  borderColor:
                    "#24582A",
                  background:
                    "#F8FCF6",
                },
            }}
          >
            {translate(
              "drag_csv_here"
            )}
          </Box>
        </>
      )}

      {rows.length >
        0 && (
        <>
          <TableContainer
            component={
              Paper
            }
            sx={{
              mb: 3,
              maxHeight:
                450,
              overflowY:
                "auto",
              border:
                "1px solid #D4E9CF",
              borderRadius:
                "16px",
              boxShadow:
                "none",
            }}
          >
            <Table
              size="small"
              stickyHeader
            >
              <TableHead>
                <TableRow>
                  <TableCell
                    sx={{
                      fontWeight: 700,
                      background:
                        "#24582A",
                      color:
                        "#FFFAF1",
                    }}
                  >
                    {translate(
                      "datetime"
                    )}
                  </TableCell>

                  <TableCell
                    sx={{
                      fontWeight: 700,
                      background:
                        "#24582A",
                      color:
                        "#FFFAF1",
                    }}
                  >
                    {translate(
                      "irrigation_mm"
                    )}
                  </TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {rows.map(
                  (
                    row,
                    i
                  ) => (
                    <TableRow
                      key={
                        i
                      }
                      hover
                    >
                      <TableCell>
                        {
                          row.datetime
                        }
                      </TableCell>

                      <TableCell>
                        {
                          row.irrigation_mm
                        }
                      </TableCell>
                    </TableRow>
                  )
                )}
              </TableBody>
            </Table>
          </TableContainer>

          <Box
            sx={{
              display:
                "flex",
              gap: 2,
              justifyContent:
                "flex-end",
            }}
          >
            <Button
              variant="outlined"
              onClick={() =>
                setRows(
                  []
                )
              }
            >
              {translate(
                "cancel"
              )}
            </Button>

            <Button
              variant="contained"
              onClick={() =>
                onNext(
                  rows
                )
              }
            >
              {translate(
                "continue"
              )}
            </Button>
          </Box>
        </>
      )}
    </Box>
  );
}